// Environment configuration for React frontend

const requiredEnvVars = ["REACT_APP_BACKEND_URL", "NODE_ENV"];
requiredEnvVars.forEach((envVar) => {
  if (!process.env[envVar]) {
    throw new Error(`Environment variable ${envVar} is not set`);
  }
});

export const CONFIG = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  NODE_ENV: process.env.NODE_ENV,
};

export const BACKEND_URL = CONFIG.BACKEND_URL;

export default CONFIG;
